<script>
  import { page } from '@inertiajs/svelte';
  import { fade } from 'svelte/transition';
  import HomeHeroVideo from './Video.svelte';
  import HomeHeroTitle from './Title.svelte';
  import HomeHeroBottom from './Bottom.svelte';
  import { onMount } from 'svelte';

  export let hero;

  let video;

  let loading = true;

  // Title animation.
  let updateTitle;
  let hideContent;

  function handleMousemove(event) {
    updateTitle(event);
  }

  onMount(() => {
    video = hero.video;
    // check if is IOS
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    console.log('IOS for hero', isIOS);

    if (hero.ios_video && (isIOS || isSafari)) {
      video = hero.ios_video;
    }
  });
</script>

<section
  class={`hero page-hero full ${hideContent ? 'hero--hide-content' : ''}`}
  on:mousemove={handleMousemove}
>
  <div class="hero__main">
    {#if loading}
      <div class="hero-loader" transition:fade>
        <div class="hero-loader__inner">
          <div
            class="hero-loader__spinner"
            style={`mask-image: url(${$page.props.asset_url}img/loader.svg);-webkit-mask-image: url(${$page.props.asset_url}img/loader.svg);`}
          />
          <img
            class="hero-loader__logo"
            src={`${$page.props.asset_url}img/caballero-logo-symbol.svg`}
            alt="Logo"
          />
        </div>
      </div>
    {/if}
    {#if video}
      <HomeHeroVideo
        bind:hideContent
        {video}
        {loading}
        on:loaded={() => {
          loading = false;
        }}
      />
    {/if}
    <div class="container hero__content">
      <HomeHeroTitle bind:update={updateTitle} title={hero.title} />
    </div>
  </div>
  <div class="hero__bottom">
    <div class="container container--medium">
      <HomeHeroBottom {hero} />
    </div>
  </div>
</section>

<style lang="scss">
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .hero {
    @include resp-max('m') {
      margin-top: 14rem;
      border-bottom: 1px solid $light-border;
    }

    overflow: hidden;
    position: relative;
    z-index: 0;

    &__main {
      @include resp-max('s') {
        height: 50vh;

        padding-bottom: 10rem;
      }
      @include resp-range('s', 'm') {
        height: 60vh;
      }
      @include resp-min('m') {
        height: 93vh;

        padding-bottom: 20rem;
      }

      position: relative;

      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }

    &__content {
      transition: opacity 0.25s;

      .hero--hide-content & {
        opacity: 0;
      }
    }

    &__bottom {
      @include resp-min('m') {
        position: absolute;
        z-index: 20;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
  }

  .hero-loader {
    position: absolute;
    z-index: 10;
    inset: 0;

    background: rgb(var(--white));

    display: flex;
    align-items: center;
    justify-content: center;

    &__spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: {
        top: -15rem;
        left: -15rem;
      }

      display: block;
      width: 30rem;
      height: 30rem;
      border-radius: 50%;

      mask-size: contain;

      background: conic-gradient(
        from 0.25turn at 50%,
        var(--aqua-2),
        rgb(var(--white))
      );

      animation: spin 3s infinite linear;
    }

    &__logo {
      width: 10rem;
    }
  }
</style>
